<template>
    <div class="note">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Note'
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .note
    {

    }
</style>